// src/Components/Forms/TypeFinancement/Salam/TypeFinancement.tsx
import { useState } from "react";
import { useAuthHeader, useAuthUser } from "../../../../Services/Auth/sessionAuth";
import { Button, Form, Space, Spin, Tabs } from 'antd';
import type { TabsProps } from 'antd';
import { UserOutlined, SafetyCertificateOutlined, DatabaseOutlined } from '@ant-design/icons';
import SweetAlert from "sweetalert2";
import { Typography } from '@mui/material';

import Utilisateur from "../../../../Models/Utilisateur";
import { Crypter } from "../../../../Functions/Security/Crypter";
import Data from '../../../../Data/Data.json';
import axios from "axios";
import { ParamSalamAgenceDto, SalamComptaAgenceDto } from "../../../../Models/ParamsSalam";

import Tab1 from "./Tab1";
import Tab2 from "./Tab2";
import Tab3 from "./Tab3";

const TypeFinancementSalam = () => {
  const auth = useAuthUser();
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()));
  const authHeader = useAuthHeader();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [comptaAgences, setComptaAgences] = useState<SalamComptaAgenceDto[]>([]);
  const [SearchGlobal, setSearchGlobal] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [Consultactv, setConsulte] = useState(false);
  const [Ajoutactv, setAjoute] = useState(false);
  const [Modifactv, setModife] = useState(true);
  const [Supprimactv, setSupprime] = useState(true);
  const [Enregactv, setEnrege] = useState(true);
  const [Actuactv, setActue] = useState(true);
  const [Annulactv, setAnnule] = useState(true);
  const [FormAct, setFormactve] = useState(true);
  const [sbmit, setSbmit] = useState("");

  // Handlers
  function HandleConsult() {
    setConsulte(true);
    setAjoute(true);
    setModife(false);
    setAnnule(false);
    setSupprime(false);
  }

  function HandleAjout() {
    form.resetFields();
    setConsulte(true);
    setAjoute(true);
    setEnrege(false);
    setActue(false);
    setAnnule(false);
    setFormactve(false);
    setSearchGlobal(true);
    setSbmit('add');
    setComptaAgences([]);
  }

  function HandleModif() {
    setEnrege(false);
    setModife(true);
    setActue(false);
    setAnnule(false);
    setFormactve(false);
    setSbmit('modif');
    setSupprime(true);
    setSearchGlobal(true);
  }

  function HandleSupp() {
    setSbmit('supp');
  }

  function HandleAnnul() {
    setConsulte(false);
    setAjoute(false);
    setModife(true);
    setEnrege(true);
    setSupprime(true);
    setActue(true);
    setAnnule(true);
    form.resetFields();
    setFormactve(true);
    setSbmit('');
    setSearchGlobal(false);
    setComptaAgences([]);
  }

  // Onglets (3)
  const items: TabsProps['items'] = [
    {
      key: '1',
      label: (
        <span>
          <UserOutlined />
          Type de financement
        </span>
      ),
      children: <Tab1 etatG={SearchGlobal} form={form} />
    },
    {
      key: '2',
      label: (
        <span>
          <DatabaseOutlined />
          Plans comptables & Agences
        </span>
      ),
      children: (
        <Tab2
          form={form}
          etatG={SearchGlobal}
          comptaAgences={comptaAgences}
          setComptaAgences={setComptaAgences}
        />
      )
    },
    {
      key: '3',
      label: (
        <span>
          <SafetyCertificateOutlined />
          Autorisations
        </span>
      ),
      children: <Tab3 form={form} />
    }
  ];

  // 🔍 Consultation – récupération des données
  function consult() {
    const code = form.getFieldValue("CodeSalam");
    if (!code) {
      SweetAlert.fire({
        title: "Veuillez renseigner le Code du type de Salam",
        icon: "warning",
      });
      return;
    }
    setLoading(true);
    const encryptedCode = Crypter.encrypt(code);
    const config = {
      method: 'get',
      url: Data.ApiUrl.ReadParamsSalam,
      headers: {
        'Authorization': authHeader(),
        'Content-Type': 'application/json',
        'CypherCodeSalam': encryptedCode
      }
    };

    axios.request(config)
      .then((response) => {
        setLoading(false);
        const res = JSON.parse(Crypter.decrypt(response.data)).Value;
       console.log(res);
        if (res.StatutCode === 200) {
          // Récupérer l'objet principal depuis Table1 (ou Table si Table1 n'existe pas)
          let data = res.Result.Table1?.[0] || res.Result.Table?.[0] || {};

          // Mapper les listes depuis les tables séparées (pour être sûr)
          data.TypeGarantieAuto = res.Result.Table2?.map((x: any) => x.CodeTypeGarantie) ?? [];
          data.CategorieActifsSalam = res.Result.Table3?.map((x: any) => x.CodeCategorie) ?? [];
          data.FraisAutorise = res.Result.Table4?.map((x: any) => x.CODOPE) ?? [];
          data.RemAuto = res.Result.Table5?.map((x: any) => x.IDPLAN) ?? [];
          //data.FournAuto = res.Result.Table6?.map((x: any) => x.IDPLAN) ?? [];


          data.ParamsSalamCompteGl = res.Result.Table6?.map((x: any) => ({
            CodeAgence: x.CodeAgence,
            CompteStockTransit: x.CompteStockTransit,
            CompteStockReel: x.CompteStockReel,
            CompteProfit: x.CompteProfit,
            CompteCharity: x.CompteCharity,
            CompteTvaDifferee: x.CompteTvaDifferee,
            CompteTvaCollecte: x.CompteTvaCollecte,
          })) ?? [];

          // Mettre à jour le formulaire
          form.setFieldsValue(data);
          // Mettre à jour l'état des comptes
          setComptaAgences(data.ParamsSalamCompteGl || []);
          HandleConsult();
        } else {
          SweetAlert.fire({ title: res.Message, text: res.Result, icon: "warning" });
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error(error);
        SweetAlert.fire({ title: "Erreur", text: error.toString(), icon: "error" });
      });
  }

  // 💾 Soumission (Create / Update)
  const onFinish = () => {
    const values = form.getFieldsValue(true);
    const paramsSalam: ParamSalamAgenceDto = {
      ...values,
      CODUTI: user.coduti,
      ParamsSalamCompteGl: comptaAgences
    };

    const isAdd = sbmit === 'add';
    const url = isAdd ? Data.ApiUrl.CreateParamsSalam : Data.ApiUrl.UpdateParamsSalam;
    const method = isAdd ? 'post' : 'put';

    SweetAlert.fire({
      title: isAdd ? "Création du Paramètre Salam" : "Mise à jour du Paramètre Salam",
      text: isAdd
        ? `Voulez-vous créer le paramètre ${paramsSalam.LibelleSalam} ?`
        : `Voulez-vous mettre à jour ${paramsSalam.CodeSalam} ?`,
      showCancelButton: true,
      confirmButtonText: "Oui",
      cancelButtonText: "Non",
      icon: "question"
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        setIsSubmit(true);
        const data = Crypter.encrypt(JSON.stringify(paramsSalam));
        axios({
          method,
          url,
          data,
          headers: { 'Authorization': authHeader(), 'Content-Type': 'application/json' }
        })
        .then((response) => {
          setLoading(false);
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;
          if (res.StatutCode === 200) {
            SweetAlert.fire({ title: res.Message, text: res.Result, icon: "success" });
            HandleAnnul();
          } else {
            SweetAlert.fire({ title: res.Message, text: res.Result, icon: "warning" });
          }
        })
        .catch((error) => {
          setLoading(false);
          console.error(error);
          SweetAlert.fire({ title: "Erreur Front", text: error.toString(), icon: "error" });
        });
      }
    });
  };

  const onFinishFailed = (errorInfo: any) => {
    const errors = errorInfo.errorFields.map((error: any) => error.name.join('.'));
    SweetAlert.fire({
      title: "Veuillez remplir tous les champs obligatoires",
      text: errors.join(' - '),
      icon: 'warning'
    });
  };

  return (
    <div className="tab">
      <Typography align="center" className="formTitle">
        <b> {window.location.pathname} </b>
      </Typography>
      <Spin spinning={loading} size="large" style={{ color: 'green' }}>
        <Form
          preserve={true}
          disabled={FormAct}
          autoComplete="off"
          labelAlign="left"
          form={form}
          name="dynamic_form_complex"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          style={{ minWidth: 'auto', maxWidth: 'auto' }}
        >
          <div className="bG">
            <legend><Typography color="darkgreen">Actions</Typography></legend>
            <Form.Item shouldUpdate className="bouttong">
              <Space direction="vertical" style={{ width: '100%' }}>
                <Button
                  size="large"
                  className="bt_add"
                  disabled={Consultactv}
                  onClick={consult}
                  type="ghost"
                  htmlType="button"
                  block
                >
                  Consulter
                </Button>
                <Button
                  size="large"
                  className="bt_add"
                  disabled={Ajoutactv}
                  onClick={HandleAjout}
                  type="ghost"
                  htmlType="button"
                  block
                >
                  Ajouter
                </Button>
                <Button
                  size="large"
                  className="bt_add"
                  disabled={Modifactv}
                  onClick={HandleModif}
                  type="ghost"
                  htmlType="button"
                  block
                >
                  Modifier
                </Button>
                <Button
                  size="large"
                  className="bt_add"
                  disabled={Enregactv}
                  type="ghost"
                  htmlType="submit"
                  block
                >
                  Enregistrer
                </Button>
                <Button
                  size="large"
                  className="bt_add"
                  disabled={Supprimactv}
                  onClick={HandleSupp}
                  type="ghost"
                  htmlType="submit"
                  block
                >
                  Désactiver
                </Button>
                <Button
                  size="large"
                  disabled={Annulactv}
                  onClick={HandleAnnul}
                  className="bt_add"
                  type="ghost"
                  htmlType="reset"
                  block
                >
                  Annuler
                </Button>
              </Space>
            </Form.Item>
          </div>
          <div className="clientP">
            <Tabs size="large" type="card" items={items} />
          </div>
        </Form>
      </Spin>
    </div>
  );
};

export default TypeFinancementSalam;